import { clearCookies } from '@shared/config';
import { useQueryClient } from '@tanstack/react-query';

export const useClearStore = () => {
  const queryClient = useQueryClient();

  const clearStore = () => {
    clearCookies();
    localStorage.clear();
    sessionStorage.clear();
    queryClient.clear();
  };

  return clearStore;
};
